import { isDevelopmentEnv } from '@/utils/CONST';
import mixpanel from 'mixpanel-browser';

class MixpanelService {

	private initialized = false;

	init () {
		const token = import.meta.env.VITE_MIXPANEL_TOKEN;

		if (!token?.length) return;

		mixpanel.init(token, {
			track_pageview: false,
			persistence: 'localStorage',
			api_host: 'https://api-eu.mixpanel.com',
			debug: isDevelopmentEnv,
		});

		this.initialized = true;
	}

	track (event: string, properties?: Record<string, unknown>) {
		if (!this.initialized) return;
		try {
			mixpanel.track(event, properties);
		}
		catch (error) {
			this.logError('track', error);
		}
	}

	identify (userId: number) {
		if (!this.initialized) return;
		try {
			mixpanel.identify(userId.toString());
		}
		catch (error) {
			this.logError('identify', error);
		}
	}

	reset () {
		if (!this.initialized) return;
		try {
			mixpanel.reset();
		}
		catch (error) {
			this.logError('reset', error);
		}
	}

	private logError (method: string, error: unknown) {
		if (isDevelopmentEnv) {
			// eslint-disable-next-line no-console
			console.error(`[Mixpanel] ${method} failed:`, error);
		}
	}

}

const mixpanelServiceSingleton = new MixpanelService();

export function useMixpanelService () {
	return mixpanelServiceSingleton;
}
